<template>
  <div class="qir-call-to-action__wrapper full-width-section">
    <div class="qir-call-to-action__container">
      <div class="qir-call-to-action__title-description-wrapper">
        <h2 class="qir-call-to-action__title title">
          Ready to Access Key Industry Insights?
        </h2>

        <p class="qir-call-to-action__description text-body">
          Get exclusive data, expert analyses, and trends shaping the FX/CFD
          brokerage industry. Don’t miss out on the latest Quarterly
          Intelligence Report.
        </p>
      </div>

      <div class="qir-call-to-action__cta-wrapper">
        <div class="qir-call-to-action__cta-img-wrapper">
          <a-image
            :src="$options.consts.CTA_IMG_SRC"
            alt="Three smartphones displaying FM Intelligence 2024 Q3 market insights, featuring a stock chart with an Indian flag, a cultural landmark, and an article layout."
          />
        </div>

        <div class="qir-call-to-action__cta-btn-box">
          Get The Report

          <a-button
            :to="$options.consts.BTN_LINK"
            :button-style="$options.consts.BUTTON_STYLE.BLACK"
            class="qir-call-to-action__cta-btn"
          >
            Here
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AButton from 'shared/AButton/index.vue'
import { ROUTE_NAME } from 'enums/routes'
import { ELEMENT_ID, ELEMENT_SELECTOR_BY_ELEMENT_ID } from 'enums/element-id'
import { BUTTON_STYLE } from 'shared/AButton/enums'

export default {
  name: 'QirCallToActionSection',
  components: { AButton },
  consts: {
    CTA_IMG_SRC: '/images/cta-img.png',
    BTN_LINK: {
      name: ROUTE_NAME.QIR,
      hash: ELEMENT_SELECTOR_BY_ELEMENT_ID[ELEMENT_ID.FORM_SECTION]
    },
    BUTTON_STYLE
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.qir-call-to-action__wrapper {
  background-color: $c--white;
  color: $c--black;

  .qir-call-to-action__container {
    max-width: $desktop-container;

    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: repeat(2, minmax(0, 100%)),
        $desktop-md: minmax(0, 100%)
      ),
      $columnGapSetup: (
        $above-desktop-xl: 64px
      ),
      $rowGapSetup: (
        $desktop-md: 32px
      )
    );

    @include gridBuilder($grid-setup);

    $padding: (
      $above-desktop-xl: 96px $padding-x-desktop-full-hd,
      $desktop-md: 64px $padding-x-desktop-md,
      $mobile: 32px $padding-x-mobile
    );

    @include setStyleByBreakpoint('padding', $padding);
  }

  .qir-call-to-action__title {
    margin-bottom: 20px;
  }

  .qir-call-to-action__description {
    color: $c--text-dark;

    @include mobile {
      font-size: 18px;
      line-height: 28px;
    }
  }

  .qir-call-to-action__cta-wrapper {
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    max-width: 640px;
    margin: 0 auto;

    @include mobile {
      flex-direction: column;
    }

    $height: (
      $above-desktop-xl: 250px
    );

    @include setStyleByBreakpoint('height', $height);
  }

  .qir-call-to-action__cta-img-wrapper {
    background: $c--gray-dark;
    flex-shrink: 0;
    overflow: hidden;

    @include desktop-md {
      width: 320px;
    }

    @include mobile {
      display: none;
    }

    /deep/ img {
      display: block;
      margin: auto;
    }
  }

  .qir-call-to-action__cta-btn-box {
    background: $c--green-main;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    font-weight: 600;

    $font-size: (
      $above-desktop-xl: 48px,
      $mobile: 30px
    );

    $line-height: (
      $above-desktop-xl: 60px,
      $mobile: 38px
    );

    $height: (
      $mobile: 250px
    );

    $padding: (
      $above-desktop-xl: 0 38px
    );

    @include setStyleByBreakpoint('padding', $padding);
    @include setStyleByBreakpoint('height', $height);
    @include setStyleByBreakpoint('line-height', $line-height);
    @include setStyleByBreakpoint('font-size', $font-size);
  }

  .qir-call-to-action__cta-btn {
    height: 36px;
    width: 100%;
    background: $c--black;
    color: $c--green-main;
    display: flex;
    justify-content: center;
    align-items: center;

    $margin-top: (
      $above-desktop-xl: 20px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);

    &:hover {
      background: $c--black !important;
    }
  }
}
</style>
